import React from "react";
import Dialog from "@mui/material/Dialog";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { Link } from 'react-router-dom';
import { WideColorButton } from '../ColorButtons/ColorButtons';

const styles = {
  centered: {
    textAlign: "center",
    borderRadius:21
  },
  display: {
    display: "flex",
    justifyContent: "center",
    alignItems:"center",
  },
  margin:{
    marginBottom:17
  },
  removeUnderline:{
    textDecoration:'none'
  },
  marginContainer:{
    marginTop:40,
    fontSize:19,
    fontWheight:"bold"
  },
  marginBottom:{
    marginBottom:37
  },
};

const WarningModal = props => {
  const { classes, show } = props;
  return (
    <Dialog
        open={show}
        className={classes.centered}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className={classes.marginContainer}> Wait! You haven't submitted your comments. </DialogTitle>
        <DialogActions className={classes.display}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={12} className={classes.margin}>
              <WideColorButton onClick={()=>props.close(false)} variant="outlined" color="primary">
                Go Back
              </WideColorButton>
            </Grid>
            <Grid item xs={12} className={classes.marginBottom}>
              <Link className={classes.removeUnderline} to={sessionStorage.getItem("redirect") ? sessionStorage.getItem("redirect") : '/'}>
              <WideColorButton onClick={()=>props.close(true)} variant="outlined" color="primary">
                Continue Without Saving
              </WideColorButton>
              </Link>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
  );
};

WarningModal.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(WarningModal);


